export const messages = {
  en: {
    privilege: {
      privilegeGroup: 'Privilege Group',
      add: 'Add',
      name: 'Name',
      code: 'Code',
      createTime: 'Create Time',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      privilege: 'Privilege'
    },
    privilegeGroup: {
      addPrivilegeGroup: 'Add Privilege Group',
      privilegeGroup: 'Privilege Group'
    },
    addPrivilegeGroup: {
      addRole: 'Add Role',
      roleName: 'Role Name',
      roleNameRequired: 'Role name is required',
      roleNameLength: 'Role name length must be between 2 and 10 characters',
      roleNamePlaceholder: 'Required, please enter role name',
      roleDesc: 'Role Description',
      roleDescPlaceholder: 'Optional, please enter role description',
      cancel: 'Cancel',
      save: 'Save',
      addSuccess: 'Added successfully'
    },
    editPrivilegeGroup: {
      editRole: 'Edit Role',
      roleName: 'Role Name',
      roleNameRequired: 'Role name is required',
      roleNameLength: 'Role name length must be between 2 and 10 characters',
      roleNamePlaceholder: 'Required, please enter role name',
      roleDesc: 'Role Description',
      roleDescPlaceholder: 'Optional, please enter role description',
      cancel: 'Cancel',
      save: 'Save',
      editSuccess: 'Modified successfully'
    },
    deletePrivilegeGroup: {
      confirmOperation: 'Please confirm your operation',
      deleteWarning: 'Deleting the privilege group will also delete all privileges under the group. Are you sure to delete role',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Deleted successfully'
    },
    addPrivilege: {
      addPrivilege: 'Add Privilege',
      inputPrivilegeName: 'Enter privilege name',
      search: 'Search',
      privilegeCode: 'Privilege Code',
      privilegeName: 'Privilege Name',
      createTime: 'Create Time',
      submit: 'Submit',
      cancel: 'Cancel',
      selectPrivilegeFirst: 'Please select privilege first',
      addSuccess: 'Added successfully'
    },
    deletePrivilege: {
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm to delete?',
      cancel: 'Cancel',
      deleteSuccess: 'Deleted successfully'
    }
  },
  zh: {
    privilege: {
      privilegeGroup: '权限组',
      add: '添加',
      name: '名称',
      code: '编码',
      createTime: '创建时间',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      privilege: '权限'
    },
    privilegeGroup: {
      addPrivilegeGroup: '添加权限组',
      privilegeGroup: '权限组'
    },
    addPrivilegeGroup: {
      addRole: '添加角色',
      roleName: '角色名称',
      roleNameRequired: '角色名称不能为空',
      roleNameLength: '角色名称长度必须在2位至10位',
      roleNamePlaceholder: '必填，请填写角色名称',
      roleDesc: '角色描述',
      roleDescPlaceholder: '选填，请填写角色描述',
      cancel: '取消',
      save: '保存',
      addSuccess: '添加成功'
    },
    editPrivilegeGroup: {
      editRole: '编辑角色',
      roleName: '角色名称',
      roleNameRequired: '角色名称不能为空',
      roleNameLength: '角色名称长度必须在2位至10位',
      roleNamePlaceholder: '必填，请填写角色名称',
      roleDesc: '角色描述',
      roleDescPlaceholder: '选填，请填写角色描述',
      cancel: '取消',
      save: '保存',
      editSuccess: '修改成功'
    },
    deletePrivilegeGroup: {
      confirmOperation: '请确认您的操作',
      deleteWarning: '删除权限组同时会删除权限组下的所有权限，确认是否删除角色',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功'
    },
    addPrivilege: {
      addPrivilege: '添加权限',
      inputPrivilegeName: '输入权限名称',
      search: '查询',
      privilegeCode: '权限编码',
      privilegeName: '权限名称',
      createTime: '创建时间',
      submit: '提交',
      cancel: '取消',
      selectPrivilegeFirst: '请先选择权限',
      addSuccess: '添加成功'
    },
    deletePrivilege: {
      confirmOperation: '请确认您的操作',
      confirmDelete: '确认是否删除',
      cancel: '点错了',
      deleteSuccess: '删除成功'
    }
  }
}